import React, { useState, useEffect } from "react";
import { RightArrowIcon } from "../../../../../utils/SvgComps";
import ProductCardComponent from "../../../ProductCard/ProductCardComponent";
import NotFoundComponent from "../../../NotFound/NotFoundComponent";
import { SessionKeys } from "../../../../../utils/AppUtils";
import { Tab, Tabs } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { getAICoachingUrl } from "../../../../../redux/coaching/actions";
import _ from "lodash";
import Loader from "../../../../Loader/Loader";

const AiCoaching = () => {
  const [key, setKey] = useState("AI");
  const dispatch = useDispatch();
  const activeLanguage = useSelector((state) => state.home.activeLanguage);
  const aiCoachingUrlRes = useSelector(
    (state) => state.coaching.aiCoachingUrlData
  );
  const [isLoading, setisLoading] = useState(false);
  const [apiCalled, setApiCalled] = useState(false);

  const getUrl = (solution, language) => {
    setApiCalled(true);
    setisLoading(true);
    dispatch(
      getAICoachingUrl({
        module: "ai-coaching-url",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          lang: language,
          roleplay_type: solution,
        },
      })
    );
  };

  useEffect(() => {
    console.log("aiCoachingUrlRes", aiCoachingUrlRes);
    if (!_.isEmpty(aiCoachingUrlRes) && apiCalled) {
      if (aiCoachingUrlRes?.status === "success") {
        let url = aiCoachingUrlRes?.payload?.payload?.url;
        window.open(url, "_blank");
        setisLoading(false);
      } else {
        setisLoading(false);
      }
    }
    setApiCalled(false);
  }, [aiCoachingUrlRes]);

  const [formattedListing, setFormattedListing] = useState([
    {
      id: "4014",
      is_like: false,
      is_bookmark: false,
      productType: "Selling energie", //"Selling an Energy Solution",
      is_wishlist: false,
      productOrigin: "xsel",
      title: "Selling energie", //"Selling an Energy Solution",
      logoURL:
        "https://cdnstg.training.com/halifax/image/8e30b7d1-7cdd-4acc-bc5f-d423714b9d8f.png",
      logoAltText: "RP",
      bannerURL:
        "https://cdn-stg.niit-mts.com/xsel/image/045d8e5d-cd34-4556-a7d8-f3f29b94f709.png",
      // "https://cdnstg.training.com/halifax/image/b48f3c8e-021c-4d54-801b-d81fb2d84670.jpg",
      tagsArray: ["Halifax", "Role play"],
      description:
        "AI-enabled coach offers dynamic, interactive experiences where the AI adapts to various characters, scenarios, and dialogues, creating immersive, personalized storytelling that responds to user actions and choices in real-time.",
      duration: "",
      showHeader: true,
      showProviderIcon: true,
      showLikeMenu: false,
      showSubmitAndReview: false,
      showSubmittedBy: false,
      submittedBy: "",
      submittedOn: "Sep 5, 2024",
      showReviewedBy: false,
      feedbackStatus: false,
      reviewedBy: "1",
      reviewedOn: "Sep 5, 2024",
      showProgres: true,
      showBody: true,
      showFooter: true,
      btnTitle: "Explore",
      cardClassName: "",
      footerLineComp: "",
      btnAction: () => {
        // window.open(
        //   window.location.origin.includes("local") ||
        //     window.location.origin.includes("192.168") ||
        //     window.location.origin.includes("dev") ||
        //     window.location.origin.includes("stg") ||
        //     window.location.origin.includes("uat")
        //     ? `https://dev.infiniit.ai/halifax-roleplay/login?token=${localStorage.getItem(
        //         SessionKeys.NEW_AI_ROLEPLAY_TOKEN
        //       )}&solution=repower&language=${activeLanguage === "1" ? "EN" : activeLanguage ==="2" ? "FR" : "EN"}` //https://demo.infiniit.ai/xsel-roleplay/?
        //     : `https://demo.infiniit.ai/halifax-roleplay/login?token=${localStorage.getItem(
        //         SessionKeys.NEW_AI_ROLEPLAY_TOKEN
        //       )}&solution=repower&language=${activeLanguage === "1" ? "EN" : activeLanguage ==="2" ? "FR" : "EN"}`,
        //   "_blank"
        // );
        const language =
          activeLanguage === "1" ? "EN" : activeLanguage === "2" ? "FR" : "EN";

        getUrl("repower", language);
      },
      descAction: () => {
        // window.open(
        //   window.location.origin.includes("local") ||
        //     window.location.origin.includes("192.168") ||
        //     window.location.origin.includes("dev") ||
        //     window.location.origin.includes("stg") ||
        //     window.location.origin.includes("uat")
        //     ? `https://dev.infiniit.ai/halifax-roleplay/login?token=${localStorage.getItem(
        //         SessionKeys.NEW_AI_ROLEPLAY_TOKEN
        //       )}&solution=repower&language=${
        //         activeLanguage === "1"
        //           ? "EN"
        //           : activeLanguage === "2"
        //           ? "FR"
        //           : "EN"
        //       }`
        //     : `https://demo.infiniit.ai/halifax-roleplay/login?token=${localStorage.getItem(
        //         SessionKeys.NEW_AI_ROLEPLAY_TOKEN
        //       )}&solution=repower&language=${
        //         activeLanguage === "1"
        //           ? "EN"
        //           : activeLanguage === "2"
        //           ? "FR"
        //           : "EN"
        //       }`,
        //   "_blank"
        // );
        const language =
          activeLanguage === "1" ? "EN" : activeLanguage === "2" ? "FR" : "EN";

        getUrl("repower", language);
      },
      bannerAction: () => {
        // window.open(
        //   window.location.origin.includes("local") ||
        //     window.location.origin.includes("192.168") ||
        //     window.location.origin.includes("dev") ||
        //     window.location.origin.includes("stg") ||
        //     window.location.origin.includes("uat")
        //     ? `https://dev.infiniit.ai/halifax-roleplay/login?token=${localStorage.getItem(
        //         SessionKeys.NEW_AI_ROLEPLAY_TOKEN
        //       )}&solution=repower&language=${
        //         activeLanguage === "1"
        //           ? "EN"
        //           : activeLanguage === "2"
        //           ? "FR"
        //           : "EN"
        //       }`
        //     : `https://demo.infiniit.ai/halifax-roleplay/login?token=${localStorage.getItem(
        //         SessionKeys.NEW_AI_ROLEPLAY_TOKEN
        //       )}&solution=repower&language=${
        //         activeLanguage === "1"
        //           ? "EN"
        //           : activeLanguage === "2"
        //           ? "FR"
        //           : "EN"
        //       }`,
        //   "_blank"
        // );
        const language =
          activeLanguage === "1" ? "EN" : activeLanguage === "2" ? "FR" : "EN";

        getUrl("repower", language);
      },
      priceInfo: {
        isFree: true,
        isPurchased: false,
        isAddToCart: false,
        isOffer: "",
        price: 0,
        offerPrice: 0,
        showText: "",
        textColor: "#292D32",
        teaserViewed: false,
        teaserAccessed: false,
      },
      isLoading: false,
      rightBtnIcon: <RightArrowIcon />,
      leftBtnIcon: "",
    },
    {
      id: "4015",
      is_like: false,
      is_bookmark: false,
      productType: "Selling pharma", // "Selling a Pharma",
      is_wishlist: false,
      productOrigin: "xsel",
      title: "Selling pharma", //"Selling a Pharma",
      logoURL:
        "https://cdnstg.training.com/halifax/image/8e30b7d1-7cdd-4acc-bc5f-d423714b9d8f.png",
      logoAltText: "RP",
      bannerURL:
        "https://cdn-stg.niit-mts.com/xsel/image/02bfa59b-d37e-4e56-8f3d-3201e8645203.png",
      // "https://cdnstg.training.com/halifax/image/b6022eb7-fce0-48f2-98b3-c62abaa486ab.jpg",
      tagsArray: ["Halifax", "Role play"],
      description:
        "AI-enabled roleplay offers dynamic, interactive experiences where the AI adapts to various characters, scenarios, and dialogues, creating immersive, personalized storytelling that responds to user actions and choices in real-time.",
      duration: "",
      showHeader: true,
      showProviderIcon: true,
      showLikeMenu: false,
      showSubmitAndReview: false,
      showSubmittedBy: false,
      submittedBy: "",
      submittedOn: "Sep 5, 2024",
      showReviewedBy: false,
      feedbackStatus: false,
      reviewedBy: "1",
      reviewedOn: "Sep 5, 2024",
      showProgres: true,
      showBody: true,
      showFooter: true,
      btnTitle: "Explore",
      cardClassName: "",
      footerLineComp: "",
      btnAction: () => {
        console.log(
          `https://dev.infiniit.ai/halifax-roleplay/login?token=${localStorage.getItem(
            SessionKeys.NEW_AI_ROLEPLAY_TOKEN
          )}&solution=aboca`
        );
        // window.open(
        //   window.location.origin.includes("local") ||
        //     window.location.origin.includes("192.168") ||
        //     window.location.origin.includes("dev") ||
        //     window.location.origin.includes("stg") ||
        //     window.location.origin.includes("uat")
        //     ? `https://dev.infiniit.ai/halifax-roleplay/login?token=${localStorage.getItem(
        //         SessionKeys.NEW_AI_ROLEPLAY_TOKEN
        //       )}&solution=aboca&language=${
        //         activeLanguage === "1"
        //           ? "EN"
        //           : activeLanguage === "2"
        //           ? "FR"
        //           : "EN"
        //       }` //https://demo.infiniit.ai/xsel-roleplay/?
        //     : `https://demo.infiniit.ai/halifax-roleplay/login?token=${localStorage.getItem(
        //         SessionKeys.NEW_AI_ROLEPLAY_TOKEN
        //       )}&solution=aboca&language=${
        //         activeLanguage === "1"
        //           ? "EN"
        //           : activeLanguage === "2"
        //           ? "FR"
        //           : "EN"
        //       }`,
        //   "_blank"
        // );
        const language =
          activeLanguage === "1" ? "EN" : activeLanguage === "2" ? "FR" : "EN";

        getUrl("aboca", language);
      },
      descAction: () => {
        // window.open(
        //   window.location.origin.includes("local") ||
        //     window.location.origin.includes("192.168") ||
        //     window.location.origin.includes("dev") ||
        //     window.location.origin.includes("stg") ||
        //     window.location.origin.includes("uat")
        //     ? `https://dev.infiniit.ai/halifax-roleplay/login?token=${localStorage.getItem(
        //         SessionKeys.NEW_AI_ROLEPLAY_TOKEN
        //       )}&solution=aboca&language=${
        //         activeLanguage === "1"
        //           ? "EN"
        //           : activeLanguage === "2"
        //           ? "FR"
        //           : "EN"
        //       }` //https://demo.infiniit.ai/xsel-roleplay/?
        //     : `https://demo.infiniit.ai/halifax-roleplay/login?token=${localStorage.getItem(
        //         SessionKeys.NEW_AI_ROLEPLAY_TOKEN
        //       )}&solution=aboca&language=${
        //         activeLanguage === "1"
        //           ? "EN"
        //           : activeLanguage === "2"
        //           ? "FR"
        //           : "EN"
        //       }`,
        //   "_blank"
        // );
        const language =
          activeLanguage === "1" ? "EN" : activeLanguage === "2" ? "FR" : "EN";

        getUrl("aboca", language);
      },
      bannerAction: () => {
        // window.open(
        //   window.location.origin.includes("local") ||
        //     window.location.origin.includes("192.168") ||
        //     window.location.origin.includes("dev") ||
        //     window.location.origin.includes("stg") ||
        //     window.location.origin.includes("uat")
        //     ? `https://dev.infiniit.ai/halifax-roleplay/login?token=${localStorage.getItem(
        //         SessionKeys.NEW_AI_ROLEPLAY_TOKEN
        //       )}&solution=aboca&language=${
        //         activeLanguage === "1"
        //           ? "EN"
        //           : activeLanguage === "2"
        //           ? "FR"
        //           : "EN"
        //       }` //https://demo.infiniit.ai/xsel-roleplay/?
        //     : `https://demo.infiniit.ai/halifax-roleplay/login?token=${localStorage.getItem(
        //         SessionKeys.NEW_AI_ROLEPLAY_TOKEN
        //       )}&solution=aboca&language=${
        //         activeLanguage === "1"
        //           ? "EN"
        //           : activeLanguage === "2"
        //           ? "FR"
        //           : "EN"
        //       }`,
        //   "_blank"
        // );
        const language =
          activeLanguage === "1" ? "EN" : activeLanguage === "2" ? "FR" : "EN";

        getUrl("aboca", language);
      },
      priceInfo: {
        isFree: true,
        isPurchased: false,
        isAddToCart: false,
        isOffer: "",
        price: 0,
        offerPrice: 0,
        showText: "",
        textColor: "#292D32",
        teaserViewed: false,
        teaserAccessed: false,
      },
      isLoading: false,
      rightBtnIcon: <RightArrowIcon />,
      leftBtnIcon: "",
    },
  ]);

  return (
    <>
      <Loader start={isLoading} />
      <div className="row mt-4">
        <div className="col-12">
          <div className="contsection">
            <Tabs
              id="controlled-tab-example"
              activeKey={key}
              onSelect={(k) => {
                setKey(k);
              }}
            >
              <Tab eventKey={"AI"} title="AI Coach">
                <div className="mt-5">
                  <div className="row coach-list g-xxl-5 g-4">
                    {formattedListing.length > 0 ? (
                      formattedListing.map((v, i) => {
                        return (
                          <ProductCardComponent
                            {...v}
                            show4={false}
                            // key={`roleplay-${i + 1}`}
                            cardClassName="videocard"
                            lastKey={false}
                            refInfo=""
                          />
                        );
                      })
                    ) : (
                      <NotFoundComponent
                        width={400}
                        height={419}
                        showBtn={false}
                        showMsg={true}
                        msgLine={"Nothing here, yet."}
                      />
                    )}
                  </div>
                </div>
              </Tab>
            </Tabs>
          </div>
        </div>
      </div>
    </>
  );
};

export default AiCoaching;
